'use strict';

import type { AutomationSchedule } from '../../Entities/Automation/AutomationSchedule';
import { EntityCollection } from '../EntityCollection';

export class AutomationScheduleCollection extends EntityCollection<AutomationSchedule> {}
